import styled, { css } from 'styled-components';

import { size } from '../layout/helpers';
import { fontBold } from '../layout/font';

export const Wrapper = styled.ul`
  --price-box-gutter: ${size(2)};

  list-style: none;
  padding: var(--price-box-gutter);
  margin: 0;
  border: 1px solid ${(props) => props.theme.color.border};
  border-radius: var(--image-border-radius, 0);
`;

interface RowProps {
  $oldPrice?: boolean;
}

export const Row = styled.li<RowProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--price-box-gutter);

  & + & {
    margin-top: calc(var(--price-box-gutter) / 4);
  }

  ${({ $oldPrice }) =>
    $oldPrice &&
    css`
      --price-text-decoration: line-through;

      color: var(--text-color-accent, ${(props) => props.theme.color.textDarkLighten});
      font-size: 0.875rem;
    `}
`;

export const Label = styled.div``;

export const Price = styled.div`
  ${fontBold};
  text-decoration: var(--price-text-decoration);
`;
